module.exports = __webpack_public_path__ + "img/mission-min.10ee0503.png";